import React from 'react';
import { CreatorMessagesLayout } from './components/Layout/Layout';
import { CreatorMessagesListView } from './modules/List/CreatorMessagesListView';
export const CreatorMessagesView = ({ showSendNewMessageButton, vm }) => {
    return (React.createElement(CreatorMessagesLayout, { showSendNewMessage: showSendNewMessageButton },
        React.createElement(CreatorMessagesListView, { vm: vm })));
};
